import messages from '@/shared/i18n/en/ui-route';
import { useT } from '@/shared/i18n/react';

/**
 * Shown while a lazily-loaded route chunk is in flight (router
 * `defaultPendingComponent`). A neutral, layout-reserving skeleton — not a
 * centered spinner — so swapping in the real page causes no jump.
 *
 * The router only renders this after `defaultPendingMs` (150ms), so fast /
 * hover-preloaded navigations never flash it. Shimmer is disabled under
 * `prefers-reduced-motion` (the global stylesheet already gates animations;
 * `motion-reduce:animate-none` is belt-and-suspenders for the pulse here).
 */
export function RoutePending() {
  const t = useT(messages);
  return (
    <div className="p-4 sm:p-6 max-w-6xl mx-auto w-full" aria-busy="true" aria-label={t('loadingLabel')}>
      <div className="h-7 w-48 rounded-md bg-[var(--bg-muted)] animate-pulse motion-reduce:animate-none" />
      <div className="mt-3 h-4 w-72 rounded bg-[var(--bg-muted)]/70 animate-pulse motion-reduce:animate-none" />
      <div className="mt-6 grid gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="h-12 rounded-lg bg-[var(--bg-muted)]/60 animate-pulse motion-reduce:animate-none"
          />
        ))}
      </div>
    </div>
  );
}
